import * as React from "react";
import { useSelector } from "react-redux";
import ReactTooltip from "react-tooltip";
import { useTranslation } from "react-i18next";
import { StoreState } from "../../../models/states/StoreState";
import { PageModel } from "../../../models/PageModel";
import LoadingEllipsis from "../shared/LoadingEllipsis";
import useSimulatedPages from "../../../hooks/useSimulatedPages";
import useScrollToActive from "../../../hooks/useScrollToActive";
import FlowPage from "./FlowPage";
import WidgetPanel from "./WidgetPanel";

interface PageProps {
    active?: boolean;
    simulated?: boolean;
    completed?: boolean;
}

export function FlowPanel() {
    const containerRef = React.useRef();
    const history = useSelector((state: StoreState) => state.interview.navigation?.history) || [];
    const currentPage = useSelector((state: StoreState) => state.interview.navigation?.currentPage);
    const { simulatedPages, simulating } = useSimulatedPages();
    const { t } = useTranslation();

    useScrollToActive(containerRef);

    let previousPageBlockIndex = -1;
    let pageIndex = -1;
    function renderPages(pages: PageModel[], props: PageProps = {}) {
        return pages.map((page) => {
            if (!page) return null;
            const showBlockName = previousPageBlockIndex !== page.blockIndex;
            previousPageBlockIndex = page.blockIndex;
            pageIndex += 1;
            return (
                <FlowPage
                    key={pageIndex}
                    page={page}
                    isFirst={pageIndex === 0}
                    showBlockName={showBlockName}
                    {...props}
                />
            );
        });
    }

    React.useEffect(() => {
        ReactTooltip.rebuild();
    }, [history, currentPage, simulatedPages]);

    return (
        <WidgetPanel title={t("debug.panels.flow.title")} containerRef={containerRef}>
            {renderPages(history, { completed: true })}
            {renderPages([currentPage], { active: true })}
            {renderPages(simulatedPages, { simulated: true })}
            {currentPage && simulating && (
                <LoadingEllipsis text={t("debug.panels.flow.simulating")} />
            )}
        </WidgetPanel>
    );
}
